<template>
  <div>
    <div>
      <h3 class="title-color">Facility Info</h3>
    </div>
    <div class="e-card-separator"></div>

    <div class="main-container" id="target">
      <div class="sub-container">
        <div>
          <h4 ref="facilityTypeLabelRef"><b>Facility Type: *</b></h4>
          <div class="form-row-input" v-for="(facilityType, index) in facilityTypes" :key="index">
            <ejs-radiobutton
              :label="facilityType.message"
              v-model="permit.ePermitSite.facilityType"
              @change="onFacilityTypeChange(facilityType.message)"
              :checked="facilityType.message === permit.ePermitSite.facilityType"
              name="ftype"
            />
          </div>
          <label class="e-error" style="padding-top: 10px" v-if="facilityTypeLabel">{{
            facilityTypeLabel
          }}</label>
        </div>
        <div style="display: flex; flex-direction: column">
          <h4 ref="permitTypeLabelRef"><b>Permit Type: *</b></h4>
          <ejs-checkbox
            label="Installation"
            :checked="permit.isInstallation"
            v-model="permit.isInstallation"
            @change="permitTypeChange"
            name="permitType"
          />
          <ejs-checkbox
            label="Removal"
            :checked="permit.isRemoval"
            @change="permitTypeChange"
            v-model="permit.isRemoval"
            name="permitType"
          />
          <ejs-checkbox
            label="Piping Replacement"
            :checked="permit.isPipingReplacement"
            @change="permitTypeChange"
            v-model="permit.isPipingReplacement"
            name="permitType"
          />
          <label
            class="e-error"
            style="padding-top: 10px; padding-left: 8px"
            v-if="permitTypeLabel"
            >{{ permitTypeLabel }}</label
          >
        </div>
        <div>
          <h4 ref="supplierCompanyLabelRef">
            <b>Supplier/Removal Company: *</b>
          </h4>
          <div
            class="form-row-input"
            v-for="(option, index) in supplierCompanyOptions"
            :key="index"
          >
            <ejs-radiobutton
              :label="option.label"
              :value="permit[option.value]"
              @change="supplierCompanyChange(option.value)"
              :checked="permit[option.value]"
              name="company"
            />
          </div>
          <label class="e-error" style="padding-top: 10px" v-if="supplierCompanyLabel">{{
            supplierCompanyLabel
          }}</label>
          <div
            ref="oilRemovalCompanyDescRef"
            class="form-row-input"
            v-if="permit.isOilRemovalCompany || permit.abovegroundFuelSupply"
          >
            <scc-input-validator
              :rules="[requiredRule]"
              :value="permit.ePermitSite.oilRemovalCompanyDesc"
              :showErrorLabel="showErrorLabelOilRemovalCompanyDesc"
              :errorLabelMessage="errorLabelMessageOilRemovalCompanyDesc"
            >
              <ejs-textbox
                float-label-type="Always"
                placeholder="Detail Information:* "
                v-model="permit.ePermitSite.oilRemovalCompanyDesc"
                @input="
                  onChange(
                    $event,
                    'oilRemovalCompanyDescRef',
                    'showErrorLabelOilRemovalCompanyDesc'
                  )
                "
                cssClass="required"
                :multiline="true"
                :rows="5"
              />
            </scc-input-validator>
          </div>
        </div>
        <div class="form-row-input" v-if="!showFacilityTypeDescription" ref="facilityTypeDescRef">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="permit.ePermitSite.facilityTypeOther"
            :showErrorLabel="showErrorLabelFacilityTypeOther"
            :errorLabelMessage="errorLabelMessageFacilityTypeOtherDesc"
          >
            <ejs-textbox
              float-label-type="Always"
              placeholder="Other Facility Type(Please specify): *"
              v-model="permit.ePermitSite.facilityTypeOther"
              :maxlength="250"
              @input="onChange($event, 'facilityTypeDescRef', 'showErrorLabelFacilityTypeOther')"
              cssClass="required"
              :multiline="true"
              :rows="5"
            />
          </scc-input-validator>
        </div>
      </div>
    </div>

    <!-- <tank-info/> -->
    <div>
      <div>
        <h3 class="title-color">Tank Info</h3>
      </div>
      <div class="e-card-separator"></div>
    </div>
    <div v-for="(tank, index) in tanksToInstall" :key="`installation${tank.ascaTankNumber}`">
      <div>
        <h4 class="title-color">Installation Tank {{ index + 1 }}:</h4>
      </div>
      <div class="main-container" v-if="permit.productCode === 'STSRWP'">
        <radio-button-tank-info
          :id="tank.ascaTankNumber"
          :isInstallationTank="true"
          :ascaTankNumber="`${tank.ascaTankNumber.toString()}`"
          :disabled="true"
        />
      </div>
      <installation-tank-info
        :ref="`installation${tank.ascaTankNumber}`"
        :tankIndex="index"
        :forDoubleWall="forDoubleWall"
        :forSingleWall="forSingleWall"
        @deleteTank="deleteTank"
        :tank="tank"
        :tankTypes="tankTypes"
        :productTypes="productTypes"
        :constructionType="constructionType"
      />
    </div>

    <div v-if="tanksToRemove.length > 0" class="e-card-separator"></div>
    <div v-for="(tank, index) in tanksToRemove" :key="`removal${tank.ascaTankNumber}`">
      <div>
        <h4 class="title-color">Removal Tank {{ index + 1 }}:</h4>
      </div>
      <div class="main-container" v-if="permit.productCode === 'STSRWP'">
        <radio-button-tank-info
          :id="tank.ascaTankNumber"
          :isRemovalTank="true"
          :disabled="true"
          :ascaTankNumber="`${tank.ascaTankNumber.toString()}`"
        />
      </div>
      <removal-tank-info
        :ref="`removal${tank.ascaTankNumber}`"
        :tankIndex="index"
        @deleteTank="deleteTank"
        :tank="tank"
        :tankTypes="tankTypes"
        :productTypes="productTypes"
        :constructionType="constructionType"
      />
    </div>
    <div style="text-align: center" id="target1">
      <ejs-button cssClass="e-custom1 margin-button" v-on:click.native="addTank()">
        <font-awesome-icon :icon="['fas', 'plus']" />
        &nbsp;Next Tank
      </ejs-button>
    </div>

    <ejs-dialog
      ref="info"
      class="dialog"
      target="#target1"
      header="Select type of work"
      :buttons="buttons"
      :content="contentTemplate"
      width="30%"
      animationSettings='{ effect: "FadeZoom" }'
      :beforeOpen="beforeOpeningDialog"
    />
    <div>
      <ejs-dialog
        class="dialog"
        ref="footerDialog"
        target="#target"
        header="Split Tank"
        :buttons="splitButtons"
        :content="splitContent"
        width="80%"
        animationSettings='{ effect: "FadeZoom" }'
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import Vue from "vue";
import {
  getFacilityType,
  getProductType,
  getTankType,
  getULCAPI,
} from "../services/permitting-api";
import { requiredRule } from "../../../shared/constants";
import SccInputValidator from "../../../components/base/scc-input-validator.vue";
import RemovalTankInfo from "./removal-tank-info.vue";
import InstallationTankInfo from "./installation-tank-info.vue";
// eslint-disable-next-line import/no-duplicates
import radioButtonTankInfoVue from "./facility-info-templates/radio-button-tank-Info.vue";
// eslint-disable-next-line import/no-duplicates
import RadioButtonTankInfo from "./facility-info-templates/radio-button-tank-Info.vue";

Vue.use(DialogPlugin);

export default {
  name: "FacilityTankInfo",
  props: {
    forDoubleWall: Array,
    forSingleWall: Array,
  },
  components: {
    SccInputValidator,
    RemovalTankInfo,
    InstallationTankInfo,
    RadioButtonTankInfo,
  },
  data() {
    return {
      showFacilityTypeDescription: false,
      facilityTypes: null,
      supplierCompanyOptions: [
        { label: "Fuel Supplier Name", value: "abovegroundFuelSupply" },
        { label: "Oil Removal Company Name", value: "isOilRemovalCompany" },
      ],
      facilityTypeLabel: null,
      supplierCompanyLabel: null,
      permitTypeLabel: null,
      requiredRule,
      showErrorLabelOilRemovalCompanyDesc: false,
      errorLabelMessageOilRemovalCompanyDesc: null,
      showErrorLabelFacilityTypeOther: true,
      errorLabelMessageFacilityTypeOtherDesc: null,
      tankTypes: null,
      constructionType: null,
      productTypes: null,
      tanksToRemove: [],
      tanksToInstall: [],
      buttons: [
        {
          click: this.okButtonClick,
          buttonModel: { content: "OK", isPrimary: true },
        },
        {
          click: this.onCancelButtonClick,
          buttonModel: { content: "CANCEL" },
        },
      ],
      contentTemplate: () => ({ template: radioButtonTankInfoVue }),
      splitButtons: [
        {
          click: this.okSplitButtonClick,
          buttonModel: { content: "OK", isPrimary: true },
        },
      ],
      splitContent:
        "<b>Each compartment of a multi-compartment tank is maintained and operated independently and therefore is recorded separately in the database. This means that each compartment is considered a separate part of the storage tank system for annual inventory control reporting.</b>",
    };
  },
  mounted() {
    // eslint-disable-next-line no-unused-expressions
    this.$refs.info?.hide();
    // eslint-disable-next-line no-unused-expressions
    this.$refs.footerDialog?.hide();
  },
  computed: {
    ...mapGetters({
      permit: "permit",
    }),
  },
  async created() {
    const { productCode } = this.permit;
    if (!productCode) {
      this.permit.productCode = this.$route.query.permitType;
    }
    if (this.permit.ePermitSite.eSiteTanks.length === 0) {
      if (this.permit.productCode !== "STSRWP") {
        this.permit.ePermitSite.eSiteTanks = [
          {
            ascaTankNumber: 1,
            isInstallationTank: productCode === "STSWP",
            isRemovalTank: productCode === "STSRP",
            isPipingBeingRemoved: false,
          },
        ];
      } else {
        this.permit.ePermitSite.eSiteTanks = [
          {
            ascaTankNumber: 1,
            isInstallationTank: true,
          },
          {
            ascaTankNumber: 2,
            isRemovalTank: true,
            isPipingBeingRemoved: false,
          },
        ];
      }
    }
    const tanks = this.permit.ePermitSite.eSiteTanks;
    if (productCode === "STSWP") {
      this.tanksToInstall = [...this.tanksToInstall, ...tanks];
    }
    if (productCode === "STSRP") {
      this.tanksToRemove = [...this.tanksToRemove, ...tanks];
    }
    if (productCode === "STSRWP") {
      this.tanksToRemove = tanks.filter((x) => x.isRemovalTank);
      this.tanksToInstall = tanks.filter((x) => x.isInstallationTank);
    }
    this.showFacilityTypeDescription = this.permit.ePermitSite.facilityType !== "Other";
    // eslint-disable-next-line no-return-assign
    await getFacilityType().then((res) => (this.facilityTypes = res.data));
    // eslint-disable-next-line no-return-assign
    await getTankType().then((res) => (this.tankTypes = res.data));
    // eslint-disable-next-line no-return-assign
    await getULCAPI().then((res) => (this.constructionType = this.filterULC_API(res.data)));
    // eslint-disable-next-line no-return-assign
    await getProductType().then((res) => (this.productTypes = res.data));
  },
  methods: {
    okButtonClick() {
      const radioButtonRefs = this.$refs.info.$children[0].$refs;
      if (radioButtonRefs.isInstallationTank.$el.checked) {
        this.addNewTank("isInstallationTank");
      } else if (radioButtonRefs.isRemovalTank.$el.checked) {
        this.addNewTank("isRemovalTank");
      }
    },
    okSplitButtonClick() {
      this.$refs.footerDialog.hide();
    },
    beforeOpeningDialog(args) {
      // eslint-disable-next-line no-param-reassign
      args.element.querySelector(".isInstallationTank").checked = false;
      // eslint-disable-next-line no-param-reassign
      args.element.querySelector(".isRemovalTank").checked = false;
    },
    addNewTank(selectedTankType) {
      const tank = {};
      const maxNum = Math.max(...this.permit.ePermitSite.eSiteTanks.map((x) => x.ascaTankNumber));
      tank.ascaTankNumber = maxNum > 0 ? maxNum + 1 : 1;
      try {
        if (this.permit.productCode !== "STSRWP") {
          tank.isRemovalTank = this.permit.productCode === "STSRP";
          tank.isInstallationTank = this.permit.productCode === "STSWP";
        } else {
          if (tank.isRemovalTank === undefined) tank.isRemovalTank = selectedTankType === "isRemovalTank";
          if (tank.isInstallationTank === undefined) tank.isInstallationTank = selectedTankType === "isInstallationTank";
        }

        if (tank.isRemovalTank) {
          tank.isPipingBeingRemoved = false;
          this.tanksToRemove.push(tank);
        } else {
          this.tanksToInstall.push(tank);
        }

        this.permit.ePermitSite.eSiteTanks.push(tank);
        this.$refs.info.hide();
        this.$parent.showToastNotification(
          "Success !",
          `${
            selectedTankType === "isRemovalTank" ? "Removal" : "Installation"
          } tank added successfully`,
          "e-toast-success",
        );
      } catch (err) {
        this.$refs.info.hide();
        this.$parent.showToastNotification(
          "Error !",
          `Error while adding ${
            selectedTankType === "isRemovalTank" ? "removal" : "installation"
          } tank`,
          "e-toast-danger",
        );
      }
    },

    onCancelButtonClick() {
      this.$refs.info.hide();
    },

    supplierCompanyChange(val) {
      const radioOptions = ["abovegroundFuelSupply", "isOilRemovalCompany"];
      this.permit[val] = true;
      const otherRadio = radioOptions.find((x) => x !== val);
      this.permit[otherRadio] = !this.permit[val];
      if (this.permit[val] || this.permit[otherRadio]) {
        this.$refs.supplierCompanyLabelRef.classList.remove("e-error");
        this.supplierCompanyLabel = null;
      }
    },

    onChange(e, ref, toShowMessage) {
      if (e.value) {
        this.$refs[ref].classList.remove("e-error");
        this[toShowMessage] = false;
      }
    },

    onFacilityTypeChange(updateVal) {
      if (updateVal) {
        this.$refs.facilityTypeLabelRef.classList.remove("e-error");
        this.facilityTypeLabel = null;
      }
      this.permit.ePermitSite.facilityType = updateVal;
      this.showFacilityTypeDescription = updateVal !== "Other";
    },

    deleteTank(data) {
      const { ascaTankNumber } = data.tank;
      if (data.tank.isRemovalTank) {
        this.tanksToRemove.splice(data.tankIndex, 1);
      } else if (data.tank.isInstallationTank) {
        this.tanksToInstall.splice(data.tankIndex, 1);
      }
      this.permit.ePermitSite.eSiteTanks = [...this.tanksToRemove, ...this.tanksToInstall];
      const updatedASCANumberTanks = this.permit.ePermitSite.eSiteTanks.filter(
        (x) => x.ascaTankNumber > ascaTankNumber,
      );
      updatedASCANumberTanks.forEach(
        // eslint-disable-next-line no-return-assign, no-param-reassign
        (tank) => (tank.ascaTankNumber -= 1),
      );
    },

    permitTypeChange() {
      if (this.permit.isInstallation || this.permit.isRemoval || this.permit.isPipingReplacement) {
        this.$refs.permitTypeLabelRef.classList.remove("e-error");
        this.permitTypeLabel = null;
      }
    },

    addTank() {
      if (this.permit.productCode === "STSRWP") {
        this.$refs.info.show();
      } else {
        this.addNewTank();
      }
    },

    filterULC_API(data) {
      return data
        ? data.filter(
          (x) => x.message !== "ULC 630"
              && x.message !== "630"
              && x.message !== "ULC 643"
              && !x.message.includes("C58")
              && !x.message.includes("C142")
              && !x.message.includes("Unknown")
              && !x.message.startsWith("Other"),
        )
        : data;
    },
  },
};
</script>

<style>
.e-btn.e-custom1 {
  background-color: black;
  color: white;
  font-weight: bold;
}
.align-tank-info-items {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.span-2 {
  grid-column: span 2;
}
.nested-1 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 5%;
}
.nested-2 {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  column-gap: 4.5%;
}
.tank-info-grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  padding: 10px;
  border-style: groove;
}
</style>
